import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SHOPPING_CART: GlameraIconDefinition = {
  name: 'shopping-cart',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-shopping-cart-body">
      <circle class="glm-shopping-cart-wheel glm-shopping-cart-wheel-left" cx="8" cy="21" r="1"></circle>
      <circle class="glm-shopping-cart-wheel glm-shopping-cart-wheel-right" cx="19" cy="21" r="1"></circle>
      <path class="glm-shopping-cart-basket" d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-shopping-cart-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './shopping-cart.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ShoppingCartIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SHOPPING_CART;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
